import {
  Box, Button, Chip,
  FormControl,
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Tab,
  Typography
} from '@mui/material';
import React, {useContext, useState} from 'react';
import {AppContext} from '@/utils/appContext';
import {useTranslation} from 'react-i18next';
import {ISearchForm} from '@/interfaces/bookingContext';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {TabContext, TabList, TabPanel} from '@mui/lab';
import {makeStyles} from 'tss-react/mui';
import {ModalUndecided} from './ModalUndecided';
import {ArrowRight, CheckCircle} from '@vectopus/atlas-icons-react';
import { g, hunify } from '@/utils/helpers';
import {useResponsive} from "@/hooks/use-responsive";

export const ModalDestinationPicker = (props: any) => {

  const appContext = useContext(AppContext);
  const {t} = useTranslation();
  const {classes} = useStyles();

  const handleDestination = (value: string) => {
    appContext.searchForms[appContext.orderIndex].property = value;
    appContext.searchForms[appContext.orderIndex].destination = '';
    appContext.searchForms[appContext.orderIndex].landscape = '';
    appContext.setSearchForms([...appContext.searchForms]);
    props.params.handleCloseModalDestinationPicker();
    appContext.getAvailability(appContext.orderIndex);
  };

  const handleArea = (value: string) => {
    appContext.searchForms[appContext.orderIndex].destination = value;
    appContext.searchForms[appContext.orderIndex].property = '';
    appContext.searchForms[appContext.orderIndex].landscape = '';
    appContext.setSearchForms([...appContext.searchForms]);
    props.params.handleCloseModalDestinationPicker();
    appContext.getAvailability(appContext.orderIndex);
  };

  const handleChangeLand = (value: string) => {
    appContext.searchForms[appContext.orderIndex].landscape = value;
    appContext.searchForms[appContext.orderIndex].property = '';
    appContext.searchForms[appContext.orderIndex].destination = '';
    appContext.setPropertySelected('');
    appContext.setSearchForms([...appContext.searchForms]);
    props.params.handleCloseModalDestinationPicker();
    appContext.getAvailability(appContext.orderIndex);
  };

  /*const [panel, setPanel] = useState('1');*/
  const [tab, setTab] = useState('2');

  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
  };

  /*const handleChangePanel = (event: React.SyntheticEvent, newValue: string) => {
    setPanel(newValue);
  };*/

  const [where, setWhere] = useState<string>('');

  const handleChangeWhere = (event: SelectChangeEvent) => {
    const {
      target: {value}
    } = event;
    appContext.setUpdateSearch(true);
    setWhere(value);
    handleDestination(value);
  };

  const handleChangeArea = (event: SelectChangeEvent) => {
    const {
      target: {value}
    } = event;
    appContext.setPropertySelected('')
    appContext.setUpdateSearch(true);
    setWhere(value);
    handleArea(value);
  };

  const downMd = useResponsive('down', 'md');

  const [notSure, setNotSure] = useState<boolean>(false);

  return (
    <Box sx={{height: '100%', overflow: 'scroll'}}>
      <Grid
        container
        alignItems={'center'}
        justifyContent={'space-evenly'}
        direction={'row'}
        pt={3}
        pb={3}
        pr={3}
        pl={3}
        sx={{borderBottom: '1px solid #F4F3EF', position: 'relative'}}>
        <Grid size={{ xs: 12 }} textAlign={'center'}>
          <Box display={'flex'} alignItems={'center'} justifyContent={'center'} position={'relative'} sx={{ cursor: 'pointer' }}>
          {
            (props.params.container === 'DrawerSearchWidget' || downMd) && (
              <Box position={'absolute'} left={'0'} display={'flex'}>
                <ArrowBackIcon onClick={() => props.params.handleCloseModalDestinationPicker()}/>
              </Box>
            )
          }
          <Typography variant={'h4'} component={'h4'}>
            {t("Dove si va?")}
          </Typography>
          </Box>
        </Grid>
      </Grid>
      {
        !notSure && (
          <Grid container direction="row" pr={4} pl={4} pt={3} pb={3} justifyContent="space-between" alignItems="flex-start" mb={4}>
            <Grid width={'100%'} className={classes.tabSelectType}>
              <TabContext value={tab}>
                <TabList onChange={handleChangeTab}>
                  {/*<Tab label={t('Destination')} value="1"/>*/}
                  <Tab label={t("Structures")} value="2"/>
                </TabList>

                {/*<TabPanel value="1" sx={{padding: 0, paddingTop: 3}}>
                  <FormControl sx={{m: 0, fontSize: 14}}>
                    <Select
                      displayEmpty
                      value={where}
                      onChange={handleChangeArea}
                      input={<OutlinedInput/>}
                      renderValue={() => {
                        if (!appContext.searchForms[appContext.orderIndex].destination) {
                          return <>{t('step1_tour_description')}</>;
                        }
                        return t(appContext.searchForms[appContext.orderIndex].destination);
                      }}>
                      <MenuItem value="all">{t('Everywhere')}</MenuItem>
                      {appContext.destinations.map((destination) => (
                        <MenuItem key={destination} value={destination}>
                          {t(destination)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TabPanel>*/}

                <TabPanel value="2" sx={{padding: 0, paddingTop: 3}}>
                  <FormControl sx={{m: 0}}>
                    <Select
                      displayEmpty
                      value={where}
                      onChange={handleChangeWhere}
                      input={<OutlinedInput/>}
                      inputProps={{'aria-label': 'Without label'}}
                      renderValue={() => {
                        if (!appContext.searchForms[appContext.orderIndex].property) {
                          return <>{t('Seleziona la struttura')}</>;
                        }
                        return t(appContext.searchForms[appContext.orderIndex].property);
                      }}>
                      <MenuItem disabled value="all">
                        {t('Seleziona la struttura')}
                      </MenuItem>
                      {appContext.properties.map(
                        (property, index) =>
                          (
                            <MenuItem key={index} value={property.code}>
                              <Typography dangerouslySetInnerHTML={hunify(property.title)}></Typography>
                              {
                                property.code === 'CE' && (
                                  <Button className={classes.chip}>{t('badge_new')}</Button>
/*
                                  <Chip label={t('badge_new')} className={classes.chip}/>
*/
                                )
                              }
                            </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TabPanel>
              </TabContext>
            </Grid>

            <Grid width={'100%'}>
              {/*<Box
                mt={4}
                pt={2}
                pb={3}
                sx={{borderTop: '1px solid #000', borderBottom: '1px solid #000'}}>
                <Typography
                  variant={'h5'}
                  component={'h5'}
                  sx={{display: 'flex', alignItems: 'center'}}>
                  <ClockTime size={22}/> <Box pl={2}>{t('Ricerche_recenti')}</Box>
                </Typography>
                <Box pt={3}>
                  <Typography variant={'h6'} component={'h6'}>
                    hu Norcenni Girasole village
                  </Typography>
                  <Typography variant={'subtitle2'} component={'p'}>
                    Da giov. 21 a dom. 24 Dec.
                  </Typography>
                  <Typography variant={'subtitle2'} component={'p'}>
                    2 persone
                  </Typography>
                </Box>
              </Box>
              {
                !notSure && (
                  <Box mt={2}>
                    <Button sx={{ backgroundColor: 'white', border: '1px solid black' }} variant={'contained'} color={'inherit'} fullWidth onClick={() => setNotSure(true)}>
                      {t('not_decide_yet?')}
                    </Button>
                  </Box>
                )
              }*/}

              <Box mt={4}>
                <Typography variant={'h5'} component={'h5'}>{t('not_sure?')}</Typography>
                <Typography variant={'body2'} component={'p'}>{t('choose_landscape')}</Typography>

                <Grid
                  container
                  direction={'row'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  textAlign={'center'}
                  spacing={2}
                  mt={3}>
                  {appContext.landscapes.map((landscape: string, index: number) => {
                    return (
                      <Grid
                        size={{ xs: 6 }}
                        pb={2}
                        key={index}
                        sx={{cursor: 'pointer'}}
                        onClick={() => {
                          handleChangeLand(landscape);
                        }}>
                        <Box sx={{ position: 'relative', minWidth: 'inherit!important' }}>
                          <Box className={appContext.searchForms[appContext.orderIndex].landscape === landscape ? classes.overlay : ''}>
                            <img
                              src={
                                'https://huopenair.s3.eu-central-1.amazonaws.com/destinations/' +
                                landscape +
                                '/cover.jpg'
                              }
                              width={'100%'}
                              height={85}
                              className={
                                appContext.searchForms[appContext.orderIndex].landscape === landscape ? classes.selected : ''
                              }
                              style={{objectFit: 'cover'}}
                              alt={t(landscape)}
                            />
                            <Box sx={{ position: 'absolute', minWidth: 'inherit!important', right: 0, left: 0, top: 'calc(55% - 30px)' }}>
                              {
                                appContext.searchForms[appContext.orderIndex].landscape === landscape && (
                                  <CheckCircle size={45} color={'#ffee00'} />
                                )
                              }
                            </Box>
                          </Box>
                        </Box>
                        <Typography variant={'h6'} component={'h6'}>
                          {t(landscape)}
                        </Typography>
                      </Grid>
                    )}
                  )}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )
      }
    </Box>
  );
};

const useStyles = makeStyles()((theme) => {
  return {
    tabSelectType: {
      button: {
        fontFamily: theme.typography.body1.fontFamily,
        textTransform: 'initial',
        fontSize: 18
      },
      '.MuiTabs-indicator': {
        backgroundColor: '#000'
      },
      '.MuiTab-root.Mui-selected': {
        color: '#000',
        fontFamily: theme.typography.h1.fontFamily
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#000!important'
      }
    },
    btn: {
      border: '2px solid #000',
      marginTop: '35px',
      button: {
        width: '100%',
        color: '#000',
        textTransform: 'initial',
        alignItems: 'baseline',
        fontSize: 18,
        height: 54,
        minHeight: 54,
        fontFamily: theme.typography.h5.fontFamily,
        maxWidth: '100%'
      },
      svg: {
        position: 'absolute',
        right: 15,
        marginBottom: '0!important'
      }
    },
    overlay: {
      height: 89,
      backgroundColor: '#000',
      overflow: 'hidden',
      minWidth: 'auto!important',
      img: {
        opacity: '0.7'
      }
    },
    selected: {
      border: '2px solid #ffee00',
    },
    chip: {
      backgroundColor: "#D4F15F",
      maxHeight: 20,
      color: "#000",
      fontSize: 12,
      borderRadius: 0,
      marginLeft: '4px',
      [theme.breakpoints.down('sm')]: {
        marginLeft: '16px'
      },
      textTransform: 'uppercase'
    },
  };
});
